import {ApiError,localDateTime} from './api';
import type {Row} from './api';
import type {Field} from './ui';
export function validationFields(error:ApiError|null):Record<string,unknown>{
 if(!error||error.status!==400)return {};
 const raw=error.data;const detail=raw&&typeof raw==='object'&&!Array.isArray(raw)&&raw.detail&&typeof raw.detail==='object'?raw.detail:raw;
 return detail&&typeof detail==='object'&&!Array.isArray(detail)?detail:{};
}
export function validationMessages(value:unknown):string[]{
 if(typeof value==='string')return [value];
 if(Array.isArray(value))return value.flatMap(validationMessages);
 if(value&&typeof value==='object')return Object.values(value).flatMap(validationMessages);
 return [];
}
export function versionConflict(error:ApiError|null):boolean{return error?.status===409&&(!error.data?.error||error.data.error==='version_conflict')}
export function sameValue(a:unknown,b:unknown):boolean{return JSON.stringify(a)===JSON.stringify(b)}
function inputValue(value:any,field:Field):any{
 if(field.type==='datetime-local'&&value)return localDateTime(String(value));
 if(field.type==='rows')return Array.isArray(value)?value.map(row=>Object.fromEntries((field.fields||[]).filter(child=>Object.hasOwn(row,child.key)).map(child=>[child.key,inputValue(row[child.key],child)]))):[];
 if(field.type==='channels')return Array.isArray(value)?value.map(row=>({type:row.type,value:row.value})):[];
 return value??(field.type==='checkbox'?false:['multi','rows','channels'].includes(field.type||'')?[]:'');
}
function declaredValueAvailable(value:any,field:Field):boolean{
 if(field.type==='rows')return Array.isArray(value)&&value.every(row=>row&&typeof row==='object'&&(field.fields||[]).every(child=>child.conflictInputOnly||(Object.hasOwn(row,child.key)&&declaredValueAvailable(row[child.key],child))));
 return value===null||typeof value!=='object'||['channels','multi'].includes(field.type||'');
}
export function currentFormValues(current:Row,fields:Field[],project?:(current:Row)=>Row){
 const projected=project?project(current):current;const values:Record<string,any>={};const missing:string[]=[];
 for(const field of fields){
  if(field.conflictInputOnly){values[field.key]='';continue;}
  // A projection may derive a declared value, but must never fill from old draft.
  if(!Object.hasOwn(projected,field.key)||!declaredValueAvailable(projected[field.key],field)){missing.push(field.key);continue;}
  values[field.key]=inputValue(projected[field.key],field);
 }
 return {values,missing};
}
export function displayFieldValue(value:any,field:Field):string{
 if(value===null||value===undefined||value==='')return 'Не заполнено';
 if(field.type==='checkbox')return value?'Да':'Нет';
 if(field.type==='select')return field.options?.find(option=>String(option.value)===String(value))?.label||String(value);
 if(field.type==='multi')return Array.isArray(value)?value.map(id=>field.options?.find(option=>String(option.value)===String(id))?.label||String(id)).join(', '):'Не заполнено';
 if(typeof value==='object')return JSON.stringify(value,null,2);
 return String(value);
}
